<template>
  <div class="PsPatientPhysicalActivity">
    <div class="row">
      <div class="row rowTitle">Actividad física</div>
      <ps-patient-btn-new-physical-activity></ps-patient-btn-new-physical-activity>
    </div>
    <div class="container">
      <div
        class="item"
        v-for="(physicalActivity, index) in patient.physcalActivities"
        :key="index"
      >
        {{ physicalActivity.description }}
        <i class="icon el-icon-edit" @click="editItem(physicalActivity)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import PsPatientBtnNewPhysicalActivity from "./PsPatientBtnNewPhysicalActivity.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "PsPatientPhysicalActivity",
  components: { PsPatientBtnNewPhysicalActivity },
  computed: {
    ...mapState("patients", ["patient"])
  },
  methods: {
    ...mapMutations("patients", [
      "PATIENTS_ITEM_PHYSICAL_ACTIVITY",
      "PATIENTS_DIALOG_PHYSICAL_ACTIVITY"
    ]),
    editItem(physicalActivity) {
      this.PATIENTS_ITEM_PHYSICAL_ACTIVITY(
        JSON.parse(JSON.stringify(physicalActivity))
      );
      this.PATIENTS_DIALOG_PHYSICAL_ACTIVITY(true);
    }
  }
};
</script>

<style scoped>
.PsPatientPhysicalActivity {
  background-color: white;
  border-radius: 20px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  width: 48%;
  margin-top: 35px;
  min-height: 200px;
  max-height: 400px;
  overflow: auto;
}
.rowTitle {
  font-size: 24px;
  font-weight: bold;
  line-height: 35px;
  align-items: center;
}
.week {
  justify-content: space-between;
}
.day {
  font-size: 20px;
  font-weight: 500;
  color: #efaf00;
}
.weight {
  font-size: 16px;
  font-weight: 500;
}
.column {
  height: 55px;
  justify-content: space-between;
}
.week .column {
  align-items: center;
}
.item {
  width: 100%;
  text-align: left;
  padding-bottom: 4px;
  margin-bottom: 8px;
  word-wrap: break-word;
  border-bottom: 1px solid #ccc;
}
.icon {
  line-height: 30px;
  margin-left: 10px;
  cursor: pointer;
  transition: 0.2s ease;
}
.icon:hover {
  font-size: 1.1rem;
  font-weight: bold;
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
  .PsPatientPhysicalActivity {
    width: 100%;
  }
}
</style>
